<template>
  <div class="welcome">
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody" :label="$t('Inicio')">
        <div class="message">
          <h1 class="text-center">{{$t('Bienvenido')}}</h1>
          <br>
          <h2 class="text-center">{{$t('Panel de administración | Inventario de Riesgos')}}</h2>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'welcome',
  created () {
    this.$store.dispatch('setTitle', this.$t('Bienvendido'));
    this.$store.dispatch('setSubTitle', this.$t('Inventario de riesgos HSE online'));
  }
}
</script>

<style scoped>
.message {
  margin-top: 10%;
}
</style>

